import React from "react"
import { Radio as AntdRadio } from "antd"
import type { RadioProps } from "antd/lib/radio"

export const Radio = ({ children, ...props }: RadioProps): JSX.Element => {
  return <AntdRadio {...props}>{children}</AntdRadio>
}
